import React from 'react'

function FormSelect({
    label,
    required = false,
    name,
    value,
    onChange,
    error,
    disabled = false,
    options = [],
    placeholder = 'Select',
}) {
    return (
        <div>

            <label className="text-sm mb-1 block">

                {label}

                {required && (
                    <span className="text-red-500 text-sm">
                        {' '}*
                    </span>
                )}

            </label>

            <select
                name={name}
                value={value}
                onChange={onChange}
                disabled={disabled}
                className={`
                    select
                    select-bordered
                    select-md
                    w-full
                    ${error ? 'border-error' : ''}
                `}
            >

                <option value="">
                    {placeholder}
                </option>

                {options.map((item) => (

                    <option
                        key={item.id}
                        value={item.id}
                    >
                        {item.name}
                    </option>

                ))}

            </select>

            {error && (
                <p className="text-red-500 text-xs mt-1">
                    {error}
                </p>
            )}

        </div>
    )
}

export default FormSelect